function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M32 7.27c0-.192 0-.415-.096-.575C31.648 5.575 30.848 5 29.504 5H3.488C2.304 5 1.024 5.448.384 6.311c-.032.032-.096.064-.128.128-.224.224-.288.544-.224.831C0 7.334 0 7.43 0 7.494v15.989C0 25.145 1.856 27 3.488 27h26.016C31.168 27 32 25.145 32 23.483V7.494 7.27zM3.488 7.015h26.016L16 17.759 2.528 7.047c.32-.064.704-.032.96-.032zm26.016 17.97H3.488c-.544 0-1.472-.927-1.472-1.502V9.189L15.36 19.837c.16.16.416.256.64.256.224 0 .48-.096.672-.256L30.016 9.19v14.294c0 .575.032 1.502-.512 1.502z",
  id: "envolope"
});

var SvgEnvolope = function SvgEnvolope(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    width: "2.285714285714286rem",
    height: "2.285714285714286rem",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEnvolope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/envolope.58cbbd80.svg";
export { ForwardRef as ReactComponent };